import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import SpacePath from "components/SpacePath";
import { SearchStacksForNavigationItem } from "shared/Stack/useSearchStacksForNavigation/gql";

const SpaceliftVcsRepoUsedBySpaceCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<SearchStacksForNavigationItem>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath spaceId={item.spaceDetails.id} fallbackName={item.spaceDetails.name} />
    </TableSimpleCell>
  );
};

export default SpaceliftVcsRepoUsedBySpaceCell;
